export const SET_LOADING = 'SET_LOADING'
export const SET_HARDWARE = 'SET_HARDWARE'
export const SET_UNKNOWN_DOCS = 'SET_UNKNOWN_DOCS'
export const SET_TTN_BIDS = 'SET_TTN_BIDS'
export const SET_TTN_RESPONSES = 'SET_TTN_RESPONSES'
